import styled from 'styled-components';

export const ButtonIcon = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0px ${({ theme }) => theme.spacing.sm};
  width: ${({ theme }) => theme.width.full};
  background-color: ${({ theme }) => theme.colors.oxfordBlue};
  border: none;
  border-radius: ${({ theme }) => theme.radius.s};
  height: ${({ theme }) => theme.height.h6};
`;
